import React, { Component } from 'react'

class Heading extends Component {
  render() {
    return (
      <div>
          <h1 className='text-5xl font-bold flex justify-center my-3'>CV Project</h1>
      </div>
    )
  }
}

export default Heading